import { useEffect } from "react";
import { NavHeader } from "../components/NavHeader";
import { Footer } from "../components/Footer";
import { Disclaimer } from "../components/Disclaimer";

const SECTIONS = [
  {
    id: "acceptance",
    title: "1. Acceptance",
    body:
      "By using Astrarium you agree to these terms. If you do not agree, please do not use the service. We may update these terms occasionally. Continued use after a change means you accept the updated terms.",
  },
  {
    id: "service",
    title: "2. What the service is",
    body:
      "Astrarium provides astrological readings composed from the birth details you enter, written with the help of a language model and grounded in traditional Western and Vedic astrological frameworks. Readings are for personal reflection, entertainment and curiosity. They are not medical, financial, legal or psychological advice.",
  },
  {
    id: "eligibility",
    title: "3. Eligibility",
    body:
      "Astrarium is intended for adults 16 years of age or older. If you are under 16, please use the service only with the involvement of a parent or guardian.",
  },
  {
    id: "your-content",
    title: "4. Your content",
    body:
      "You retain ownership of the birth details and questions you submit. By submitting them you grant Astrarium a limited license to process them in order to compose your reading, store a shared reading for the seven-day window if you choose to share it, and improve the service in aggregate, anonymised form. We do not sell or rent your data.",
  },
  {
    id: "acceptable-use",
    title: "5. Acceptable use",
    body:
      "Do not use Astrarium to harass, defame, threaten or harm another person. Do not attempt to scrape, automate, reverse-engineer or interfere with the service. Do not submit content that is unlawful, infringing or designed to manipulate the service.",
  },
  {
    id: "ai-disclosure",
    title: "6. AI disclosure",
    body:
      "Astrarium uses a large language model to compose the prose of your reading. The astrological framework underneath (sun sign, element, modality, ruling planet, planetary rulerships of lucky signals) is deterministic and rooted in traditional practice. The interpretive prose is generated and may, on rare occasions, contain errors or phrasings we did not intend. If something looks wrong, please write to us.",
  },
  {
    id: "no-advice",
    title: "7. Not professional advice",
    body:
      "Astrarium readings are not a substitute for advice from a qualified doctor, financial planner, lawyer, therapist or any other professional. For decisions in those areas, please consult someone you trust who is qualified to advise on them.",
  },
  {
    id: "warranties",
    title: "8. Warranties and liability",
    body:
      "Astrarium is provided on an as-is basis. We make no warranties about the accuracy, completeness or fitness for any purpose of the readings. To the maximum extent permitted by law, Astrarium will not be liable for any indirect, incidental, consequential or punitive damages arising from your use of the service.",
  },
  {
    id: "termination",
    title: "9. Termination",
    body:
      "We may suspend or terminate access to the service at any time, with or without notice, if we believe these terms have been breached or if continued operation would risk other users or the service itself.",
  },
  {
    id: "law",
    title: "10. Governing law",
    body:
      "These terms are governed by the laws applicable in the jurisdiction where Astrarium operates. Any disputes will be resolved in the competent courts of that jurisdiction, unless otherwise required by mandatory consumer-protection law.",
  },
  {
    id: "contact-terms",
    title: "11. Contact",
    body:
      "For questions about these terms write to hello@astrarium.app and we will respond.",
  },
];

export const TermsPage = () => {
  useEffect(() => {
    document.title = "Terms of Use · Astrarium";
  }, []);
  return (
    <>
      <NavHeader />
      <main
        data-testid="terms-page"
        className="relative z-10 max-w-3xl mx-auto px-4 sm:px-6 pt-28 sm:pt-32 pb-12"
      >
        <p className="text-stardust/70 uppercase tracking-[0.5em] text-[10px] mb-5 text-center">Quietly, in writing</p>
        <h1 className="font-display text-4xl sm:text-6xl text-[#F5EBD8] text-center leading-tight mb-5">
          Terms of use<span className="text-stardust">.</span>
        </h1>
        <p className="font-serif-italic text-slate-300/90 text-base sm:text-lg leading-relaxed text-center mb-14 max-w-2xl mx-auto">
          The plain-English version of how Astrarium works as a service.
        </p>

        <div className="space-y-10 text-slate-300">
          {SECTIONS.map((s) => (
            <section key={s.id} id={s.id} data-testid={`terms-${s.id}`}>
              <h2 className="font-display text-2xl sm:text-3xl text-[#F5EBD8] mb-3 leading-tight">{s.title}</h2>
              <p className="leading-relaxed">{s.body}</p>
            </section>
          ))}
        </div>

        <p className="text-slate-500 text-xs italic mt-12">Last updated, February 2026.</p>

        <Disclaimer />
      </main>
      <Footer />
    </>
  );
};
